











import { watch } from '@nuxtjs/composition-api';
import { TypeBody, TypeDisplay } from '@bambeehr/pollen'
import useCookiePolicy from '@/modules/CookiePolicy/hooks/useCookiePolicy/useCookiePolicy'
import { TrackEvents as CookieTrackEvents } from '@/modules/CookiePolicy/constants/analytics'
import useGlobalSettings from '@/hooks/useGlobalSettings';


export default {
  name: 'CookiePolicy',
  components: {
    TypeBody,
    TypeDisplay,
  },


  setup() {
        const { setHeader } = useGlobalSettings();

    setHeader({
      header: 'Cookie Policy',
      subheader: null,
      heroImage: null,
      metaTitle: `Cookie Policy`,
      registration: false,
      noHero: false,
    });

    const { isReady: isCookiePolicyReady, policy, trackCookieEvent } = useCookiePolicy();

    watch(isCookiePolicyReady, (newVal) => {
      if (newVal) {
        trackCookieEvent(CookieTrackEvents.FULL_POLICY_VIEWED)
      }
    }, { immediate: true });

    return {
      policy,
    };
  },
};
